






















import Vue from 'vue'
import vClickOutside from 'v-click-outside'
import { Point } from '@/@types'

import emojis from './emojis.json'

interface Data {
  emojis: Record<string, Record<string, string>>
  point: Point
  isVisible: boolean
}

interface Methods {
  handleToggle: (e: MouseEvent) => void
  handleClose: () => void
  handleEmoji: (emoji: string) => void
}

const DEFAULT_POINT: Point = { x: 0, y: 0 }

export default Vue.extend<Data, Methods, {}>({
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      emojis,
      point: DEFAULT_POINT,
      isVisible: false,
    }
  },
  methods: {
    handleToggle(e): void {
      this.point = { x: e.clientX, y: e.clientY }
      this.isVisible = !this.isVisible
    },
    handleClose(): void {
      this.isVisible = false
      this.point = DEFAULT_POINT
    },
    handleEmoji(emoji: string) {
      this.$emit('emoji', emoji)
    },
  },
})
